// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610091105/js/" + chunkId + "." + {"44":"9094a739","225":"34ece8e0","481":"1b0b912d","486":"2fb47758","770":"bb082a25"}[chunkId] + ".0.5749329044898971.chunk.js";
};